module.exports = __webpack_public_path__ + "assets/img/ability19.4121cdb6.png";